import React        from 'react';
import {NavLink}    from 'react-router-dom';

const Navigation = props => {
    return(
        <div className='nav-wrap'>
            <NavLink
                exact
                to='/'
            >about</NavLink>
            <span>&nbsp;|&nbsp;</span>
            <NavLink
                exact
                to='/contact'
            >contact</NavLink>
            <span>&nbsp;|&nbsp;</span>
            <NavLink
                exact
                to='/cv'
            >cv</NavLink>
        </div>
    );
}

export default Navigation;


// WEBPACK FOOTER //
// ./src/components/nav/index.js